<div class="w-100">
    <div class="page-info"><h3 style="margin: 25px; font-weight: 500; font-size:25px; color: #2a457a;">Purpose Ledger Mapping</h3></div>
</div>

<div class="table-container" style="margin-left: 20px; margin-right: 20px;">
    <div class="w-100 border-p">
        <div class="mt-10 w-100">

            <!-- Transaction Category -->
            <mat-form-field class="w-30 pl-20" appearance="outline">
                <mat-label class="custom-mat-label">Transaction Category</mat-label>
                <mat-select [(ngModel)]="l_purposeLedgerMapHdr.txncategory.txncategoryId"
                    (selectionChange)="lFN_GetPurposeSelect($event)" required>
                    <mat-option *ngFor="let l_category of l_categorySelect" [value]="l_category.txncategoryId">
                        {{ l_category.name }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Transaction Purpose -->
            <mat-form-field class="w-30 pl-20" appearance="outline">
                <mat-label class="custom-mat-label">Transaction Purpose</mat-label>
                <mat-select [(ngModel)]="l_purposeLedgerMapHdr.purpose.purposeId" required
                    (selectionChange)="lFN_GenerateModePaymentList();">
                    <mat-option *ngFor="let l_purpose of l_purposeSelect" [value]="l_purpose.purposeId">
                        {{ l_purpose.purpose }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Mode of Payment -->
            <mat-form-field class="w-30 pl-20" appearance="outline">
                <mat-label class="custom-mat-label">Mode of Payment</mat-label>
                <mat-select [(ngModel)]="l_purposeLedgerMapHdr.modeOfPayment" required>
                    <mat-option *ngFor="let modeOfPayment of modeOfPaymentEnum" [value]="modeOfPayment.value">
                        {{ modeOfPayment.viewValue }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <!-- Ledger Heads Multiselect -->
            <mat-form-field class="w-30 pl-20" appearance="outline">
                <mat-label class="custom-mat-label">Map Ledger Heads</mat-label>
                <mat-select [(value)]="l_selectedLedgerHeadVals" multiple>
                <mat-option *ngFor="let l_ledgerHead of l_ledgerHeadList" [value]="l_ledgerHead.ledgerHeadId">
                    <span class="custom-mat-label">
                    {{ l_ledgerHead.name }} - 
                    <ng-container [ngSwitch]="l_ledgerHead.entryType">
                        <span *ngSwitchCase="'C'" class="credit-label">CREDIT</span>
                        <span *ngSwitchCase="'D'" class="debit-label">DEBIT</span>
                    </ng-container>
                    </span>
                </mat-option>
                </mat-select>
            </mat-form-field>
    
            <button mat-raised-button color="primary" class="custom-button-blue pl-20"
                style="margin-top: 4px; margin-left: 10px;" (click)="lFN_SaveMasterMapping();">Submit
            </button>

        </div>
    </div>
</div>

<div class="mat-elevation-z8 table-container" style="margin-left: 20px; margin-right: 20px; margin-top: 30px;">
    <table mat-table [dataSource]="dataSource" class="mat-table">
        <!-- Txncategory Column -->
        <ng-container matColumnDef="txncategory">
            <th mat-header-cell *matHeaderCellDef>Txncategory</th>
            <td mat-cell *matCellDef="let element">{{element.txncategory.name}}</td>
        </ng-container>
    
        <!-- Purpose Column -->
        <ng-container matColumnDef="purpose">
            <th mat-header-cell *matHeaderCellDef>Purpose</th>
            <td mat-cell *matCellDef="let element">{{element.purpose.name}}</td>
        </ng-container>
      
        <!-- Mode Payment Column -->
        <ng-container matColumnDef="modeOfPayment">
            <th mat-header-cell *matHeaderCellDef>Mode Payment</th>
            <td mat-cell *matCellDef="let element">{{element.modeOfPayment}}</td>
        </ng-container>

        <!-- Approval Status Column -->
        <ng-container matColumnDef="approvalStatus">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element" class="actions-cell">
                <button mat-icon-button *ngIf="element.approvalStatus === false" (click)="lFN_ApproveMapping(element);">
                    <mat-chip class="status-chip active-status">
                        <mat-label>Approve</mat-label>
                    </mat-chip>
                </button>
                <button mat-icon-button *ngIf="element.approvalStatus === true">
                    <mat-chip class="status-chip final-status">
                        <mat-label>Mapped</mat-label>
                    </mat-chip>
                </button>
            </td>
        </ng-container>
                
  
        <!-- Actions -->
        <ng-container matColumnDef="actions">
            <th mat-header-cell *matHeaderCellDef>&nbsp;&nbsp;&nbsp;Actions</th>
            <td mat-cell *matCellDef="let element" class="actions-cell">
                <button mat-icon-button (click)="lFN_ViewMapping(element);">
                    <mat-icon title="View Mapping" style="-webkit-text-fill-color: #2a457a">visibility</mat-icon>
                </button>
                <button mat-icon-button *ngIf="element.approvalStatus === false" (click)="lFN_EditLedgerMapping(element);">
                    <mat-icon title="Edit Mapping" style="-webkit-text-fill-color: #2a457a">edit</mat-icon>
                </button>                        
            </td>
        </ng-container>
    
        <!-- Mappings -->
        <ng-container matColumnDef="mapping">
            <th mat-header-cell *matHeaderCellDef>Mapped</th>
            <td mat-cell *matCellDef="let element" class="actions-cell">
                <button mat-icon-button *ngIf="element.mapexternal">
                <mat-icon title="Mapping required for this receipt" class="posting-icon">exit_to_app</mat-icon>
                </button>
                <button mat-icon-button *ngIf="(element.mapexternal == false)">
                <mat-icon title="Mapping completed" class="bold-icon">done_outline</mat-icon>
                </button>
            </td>
        </ng-container>
  
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  
    <mat-paginator
      [pageSizeOptions]="[10, 20, 30]"
      showFirstLastButtons
    ></mat-paginator>
</div>